module.exports = __webpack_public_path__ + "static/media/the_svgwhole.677f8c10.svg";